import { SortItemType } from "@website/ticket-ui/common/types";

export const InterFlightSortListSchema: Array<SortItemType> = [
  {
    label: "پیشنهاد اسنپ‌تریپ",
    value: "recommended"
  },
  {
    label: "بهترین پرواز",
    value: "best_price"
  },
  {
    label: "ارزانترین",
    value: "lowest_price"
  },
  {
    label: "گرانترین",
    value: "highest_price"
  },
  {
    label: "کمترین مدت پرواز",
    value: "lowest_flight_duration"
  },
  {
    label: "زودترین",
    value: "earliest"
  },
  {
    label: "دیرترین",
    value: "latest"
  }
];

export const DomFlightSortListSchema: Array<SortItemType> = [
  {
    label: "پیشنهاد اسنپ‌تریپ",
    value: "recommended"
  },
  {
    label: "ارزانترین",
    value: "lowest_price"
  },
  {
    label: "گرانترین",
    value: "highest_price"
  },
  {
    label: "کمترین مدت پرواز",
    value: "lowest_flight_duration"
  },
  {
    label: "زودترین",
    value: "earliest"
  },
  {
    label: "دیرترین",
    value: "latest"
  }
];

export const BusSortListSchema: Array<SortItemType> = [
  {
    label: "ارزانترین",
    value: "lowest_price"
  },
  {
    label: "گرانترین",
    value: "highest_price"
  },
  {
    label: "زودترین",
    value: "earliest"
  },
  {
    label: "دیرترین",
    value: "latest"
  }
];
